module.exports = __webpack_public_path__ + "57c7441cd24335f2499d011e2b068b77.woff";


//////////////////
// WEBPACK FOOTER
// ./~/demo-ui/asset/icon-font/fontello.woff
// module id = 700
// module chunks = 0